import React, { createContext, useReducer } from "react"

const initialState = {items: {}, user: {}, fuelMetrix: {}, token: "", socketEvents: {}, appsVersion: {}, notifications: {}, userCompanies: []};
const GlobalContext = createContext(initialState);
const { Provider } = GlobalContext;

const GlobalContextProvider = ( {value, children } ) => {
    const [state, dispatch] = useReducer(
        (state, action) => {
            switch (action.type) {
                case "add_item":
                    let new_items = Object.assign({}, state.items,  action.value );
                    return Object.assign({}, state, { items: new_items });
                case "update_item":
                    Object.keys(state.items).forEach(key => state.items[key] = Object.assign({}, state.items[key], action.value[key] || {}));
                    return Object.assign({}, state);
                case "add_socket_event" :
                    let socketEvents = Object.assign({}, state.socketEvents, action.value);
                    state.socketEvents = JSON.parse(JSON.stringify(socketEvents))
                    return  Object.assign({}, state);
                case "remove_socket_events" :
                    let notReadEvents = Object.keys(state.socketEvents || {}).reduce((res, key) =>{
                        if (!action.value.includes(key))
                            res[key] = state.socketEvents[key];
                        return res;
                    }, {});
                    return  Object.assign({}, state, { socketEvents: notReadEvents });
                case "update_fuel_metrix" : {
                    const fuelMetrix =  Object.assign({}, state.fuelMetrix, action.value)
                    return  Object.assign({}, state, { fuelMetrix });
                }
                case "update_apps_version" : {
                    return  Object.assign({}, state, { appsVersion:  action.value})
                }
                case "create_notifications" : {
                    return  Object.assign({}, state, { notifications:  action.value})
                }
                case "update_notifications" : {
                    let notifications = JSON.parse(JSON.stringify(state.notifications))

                    notifications[action.value.name] = notifications[action.value.name] || {};
                    if(action.value.count?.action === "inc"){
                        notifications[action.value.name].count = (notifications[action.value.name].count || 0) + action.value.count.value;
                    }
                    else if(action.value.count?.action === "replace"){
                        notifications[action.value.name].count = action.value.count.value;
                    }
                    else if(action.value.date)
                        notifications[action.value.name].date = action.value.date;
                    return  Object.assign({}, state, {notifications})
                }
                default:
                    console.error(action.type)
                    // throw new Error();
            }
        },
        { ...initialState, ...value }
    );

    return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { GlobalContext, GlobalContextProvider }

export default GlobalContext
